import { UniqMap } from 'src/lib/UniqMap';
import {
  GENERATION_BLOG_GROUP,
  GENERATION_TOOL,
  GENERATION_TOOL_GROUP,
  GENERATION_WTM_GROUP,
} from './const';
import { PROJECT_BLOG_CASES, PROJECT_WTM_CASES } from 'src/data/project';

const TOOL_GROUPS = new UniqMap();

TOOL_GROUPS.add(GENERATION_TOOL_GROUP.ads, [
  GENERATION_TOOL.facebookPrimaryTextProduct,
  GENERATION_TOOL.facebookHeadlineProduct,
  GENERATION_TOOL.facebookPrimaryTextProductRewrite,
  GENERATION_TOOL.googleRSA,
  GENERATION_TOOL.googleHeadlineProduct,
  GENERATION_TOOL.googleDescriptionProduct,
  GENERATION_TOOL.googleHeadlineProductRewrite,
  GENERATION_TOOL.googleDescriptionProductRewrite,
  GENERATION_TOOL.outbrainHeadlineProduct,
  GENERATION_TOOL.outbrainHeadlineProductRewrite,
  GENERATION_TOOL.taboolaHeadlineProduct,
  GENERATION_TOOL.taboolaHeadlineProductRewrite,
  GENERATION_TOOL.twitterCopyProduct,
  GENERATION_TOOL.twitterTitleProduct,
  GENERATION_TOOL.twitterCopyProductRewrite,
  GENERATION_TOOL.linkedinIntroSingleImage,
  GENERATION_TOOL.linkedinHeadlineSingleImage,
  GENERATION_TOOL.linkedinIntroSingleImageRewrite,
  GENERATION_TOOL.linkedinHeadlineSingleImageRewrite,
  GENERATION_TOOL.pinterestDescriptionProduct,
  GENERATION_TOOL.pinterestTitleProduct,
  GENERATION_TOOL.pinterestDescriptionProductRewrite,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.landingPage, [
  GENERATION_TOOL.landingHeadline,
  GENERATION_TOOL.landingHeadlineRewrite,
  GENERATION_TOOL.landingSubheader,
  GENERATION_TOOL.landingSubheaderRewrite,
  GENERATION_TOOL.landingCTA,
  GENERATION_TOOL.landingBenefits,
  GENERATION_TOOL.landingFeatures,
  GENERATION_TOOL.landingSEOMetadata,
  GENERATION_TOOL.landingSEOMetadataRewrite,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.social, [
  GENERATION_TOOL.instagramCaption,
  GENERATION_TOOL.instagramCaptionRewrite,
  GENERATION_TOOL.facebookPost,
  GENERATION_TOOL.facebookPostRewrite,
  GENERATION_TOOL.tweet,
  GENERATION_TOOL.tweetRewrite,
  GENERATION_TOOL.linkedinPost,
  GENERATION_TOOL.linkedinPostRewrite,
  GENERATION_TOOL.pinterestPostDescription,
  GENERATION_TOOL.pinterestPinDescriptionRewrite,
  GENERATION_TOOL.pinterestPostTitle,
  GENERATION_TOOL.pinterestPinTitleRewrite,
  GENERATION_TOOL.youtubeDescription,
  GENERATION_TOOL.youtubeTitle,
  GENERATION_TOOL.facebookPrimaryTextContent,
  GENERATION_TOOL.facebookHeadlineContent,
  GENERATION_TOOL.outbrainHeadlineContent,
  GENERATION_TOOL.taboolaHeadlineContent,
  GENERATION_TOOL.twitterCopyContent,
  GENERATION_TOOL.pinterestDescriptionContent,
  GENERATION_TOOL.pinterestTitleContent,
  GENERATION_TOOL.basicQuoraAnswers,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.email, [
  GENERATION_TOOL.emailSubjectLine,
  GENERATION_TOOL.emailPromotionalSubjectLine,
  GENERATION_TOOL.emailPromotionalBody,
  GENERATION_TOOL.emailColdOutreachSubjectLine,
  GENERATION_TOOL.emailColdOutreachBody,
  GENERATION_TOOL.emailSubjectLineRewrite,
  GENERATION_TOOL.emailColdOutreachBodyRewrite,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.sms, [
  GENERATION_TOOL.smsPromotional,
  GENERATION_TOOL.smsPromotionalRewrite,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.generalWriting, [
  GENERATION_TOOL.basicContentImprover,
  GENERATION_TOOL.basicEli5,
  GENERATION_TOOL.basicSentenceExpander,
  GENERATION_TOOL.basicPersuasiveBulletPoint,
  GENERATION_TOOL.basicFeatureToBenefitsPractical,
  GENERATION_TOOL.basicValueProposition,
  GENERATION_TOOL.basicTalkingPointsToParagraph,
  GENERATION_TOOL.summarizer,
  GENERATION_TOOL.basicPersonalBio,
  GENERATION_TOOL.basicCompanyBio,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.copywritingFrameworks, [
  GENERATION_TOOL.basicAida,
  GENERATION_TOOL.basicPas,
  GENERATION_TOOL.basicBab,
  GENERATION_TOOL.basicEngagingQuestions,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.ideation, [
  GENERATION_TOOL.basicBlogIdeas,
  GENERATION_TOOL.basicVideoIdeas,
]);
TOOL_GROUPS.add(GENERATION_TOOL_GROUP.productListing, [
  GENERATION_TOOL.amazonProductListing,
  GENERATION_TOOL.walmartProductListing,
  GENERATION_TOOL.generalProductListing,
  GENERATION_TOOL.basicProductReview,
  GENERATION_TOOL.basicPerfectHeadline,
]);

TOOL_GROUPS.add(GENERATION_TOOL_GROUP.articleBlog, [GENERATION_TOOL.articleBlogHeadline]);

TOOL_GROUPS.add(GENERATION_TOOL_GROUP.anyCopy, [GENERATION_TOOL.createYourOwn]);

TOOL_GROUPS.add(GENERATION_BLOG_GROUP.blog, [PROJECT_BLOG_CASES.description]);

TOOL_GROUPS.add(GENERATION_WTM_GROUP.wtm, [PROJECT_WTM_CASES.default]);

export const getToolsByGroup = (toolGroup) => TOOL_GROUPS.get(toolGroup) || [];

export const getGroupByTool = (tool) =>
  [...TOOL_GROUPS.map.keys()].find((group) => getToolsByGroup(group).includes(tool));

export const getTeadsTools = () => [
  GENERATION_TOOL.teadsSingleVideoHeadline,
  GENERATION_TOOL.teadsSingleVideoDescription,
];

export const getRewriteHeadlineTools = () => [
  GENERATION_TOOL.pinterestPinTitleRewrite,
  GENERATION_TOOL.linkedinHeadlineSingleImageRewrite,
  GENERATION_TOOL.emailSubjectLineRewrite,
  GENERATION_TOOL.landingSubheaderRewrite,
  GENERATION_TOOL.landingHeadlineRewrite,
  GENERATION_TOOL.taboolaHeadlineProductRewrite,
  GENERATION_TOOL.outbrainHeadlineProductRewrite,
];

export const isGenerationToolInSocialGroup = (generationTool) => {
  const toolGroup = getGroupByTool(generationTool);
  return toolGroup === GENERATION_TOOL_GROUP.social;
};

export const isGenerationToolInProductListingGroup = (generationTool) => {
  const toolGroup = getGroupByTool(generationTool);
  return toolGroup === GENERATION_TOOL_GROUP.productListing;
};

export const isGenerationToolInAdsGroup = (generationTool) => {
  const toolGroup = getGroupByTool(generationTool);
  return toolGroup === GENERATION_TOOL_GROUP.ads;
};
